export default "__VITE_ASSET__DvJM7M1M__"